"use client";

import type { ResolvedMoneyPresentation } from "@/lib/pricing/resolve-display-money";

export type PricingResolveItem = { id: string } & ResolvedMoneyPresentation;

function dummyMoney(currency: string) {
	return { amount: 0, currency };
}

/**
 * Resolve display labels for money amounts (channel currency only).
 * Only `items` in the response are used by callers.
 */
export async function fetchPricingResolveItems(params: {
	locale: string;
	channel: string;
	items: Array<{ id: string; amount: number; currency: string }>;
}): Promise<PricingResolveItem[] | null> {
	if (params.items.length === 0) return [];

	const cur = params.items[0]!.currency;

	try {
		const res = await fetch("/api/pricing/resolve", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				locale: params.locale,
				channel: params.channel,
				country: null,
				items: params.items,
				totals: {
					subtotal: dummyMoney(cur),
					total: dummyMoney(cur),
				},
				shippingThreshold: dummyMoney(cur),
			}),
		});
		if (!res.ok) return null;
		const data = (await res.json()) as { items: PricingResolveItem[] };
		return data.items;
	} catch {
		return null;
	}
}

export function pricingItemsById(items: PricingResolveItem[]): Map<string, ResolvedMoneyPresentation> {
	const m = new Map<string, ResolvedMoneyPresentation>();
	for (const it of items) {
		const { id, ...pres } = it;
		m.set(id, pres);
	}
	return m;
}
